import { createSlice } from '@reduxjs/toolkit';
import type { EscritorioLookup, UsuarioLookup } from '../../types/lookups';
import { fetchEscritoriosLookup, fetchUsuariosLookup } from './actions';

interface AdminLookupsState {
  escritorios: EscritorioLookup[];
  usuarios: UsuarioLookup[];
  loading: boolean;
}

const initialState: AdminLookupsState = {
  escritorios: [],
  usuarios: [],
  loading: false,
};

const adminLookupsSlice = createSlice({
  name: 'adminLookups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEscritoriosLookup.fulfilled, (state, action) => {
        state.escritorios = action.payload.data;
      })
      .addCase(fetchUsuariosLookup.fulfilled, (state, action) => {
        state.usuarios = action.payload.data;
      });
  },
});

export const adminLookupsReducer = adminLookupsSlice.reducer;
